module.exports = "<booking-page></booking-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appBooking.html
// module id = 1245
// module chunks = 0